import { NotFoundBrand } from "@components/widgets/ErrorPage";
import { useGetBrandForDocumentsQuery } from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/brands/page-loading";
import { NavigationBrand } from "@src/components/widgets/AppSubNav/NavigationBrand";
import { getQueryParam } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useState } from "react";
import {
  DocumentsCtx,
  StoreDocuments,
} from "../../documents/listing/StoreDocuments";
import { TableModuleDocuments } from "../../documents/listing/TableModuleDocuments";
import { MixedFilters } from "./MixedFilters";

export const PageDocuments = observer(function PageDocuments() {
  const { query } = useRouter();

  const brandId = getQueryParam("id", query);
  const { data, loading } = useGetBrandForDocumentsQuery({
    variables: { id: brandId },
  });

  const [documentsStore] = useState(() => {
    const store = new StoreDocuments(new MixedFilters(brandId), true);
    store.setPrefillFormFields({ brandId });
    return store;
  });

  if (loading) {
    return <PageLoading brandId={brandId} />;
  }

  if (!data?.brand) {
    return <NotFoundBrand />;
  }

  return (
    <DocumentsCtx.Provider value={documentsStore}>
      <TableModuleDocuments
        navigation={<NavigationBrand id={brandId} variant="page" />}
      />
    </DocumentsCtx.Provider>
  );
});
